/* global Office, console */
import * as MESSAGES from "../MESSAGES";
//import * as logger from "../logger/logger";
import * as CONSTANTS from "../CONSTANTS";

let _customProps;

// Set an add-in setting.
export function saveUsernamePassword(username, password) {
  let _settings = Office.context.roamingSettings;
  if (username != null) {
    _settings.set(CONSTANTS.USERNAME, username);
  }
  if (password != null) {
    _settings.set(CONSTANTS.PASSWORD, password);
  }
  _settings.saveAsync(saveMyAppSettingsCallback);
}

export function fillUsernamePassword(username, password) {
  let _settings = Office.context.roamingSettings;
  if (_settings.get(CONSTANTS.USERNAME) != null) {
    username.val(_settings.get(CONSTANTS.USERNAME));
    password.val(_settings.get(CONSTANTS.PASSWORD));
  }
}

// Saves all roaming settings.
export function saveMyAppSettingsCallback(asyncResult) {
  if (asyncResult.status == Office.AsyncResultStatus.Failed) {
    console.error(MESSAGES.CANNOT_SAVE_APP_SETTINGS);
  }
}

// Get the item's custom properties from the server and save for later use.
export function setCustoProps(value) {
  _customProps = value;
}

// Sets or updates the specified property, and then saves the change
// to the server.
export function updateProperty(name, value) {
  _customProps.set(name, value);
  _customProps.saveAsync(saveCallback);
}

// Removes the specified property, and then persists the removal
// to the server.
export function removeProperty(name) {
  _customProps.remove(name);
  _customProps.saveAsync(saveCallback);
}

// Get individual custom property.
export function getProperty(name) {
  return _customProps.get(name) || false;
}

// Callback for calls to saveAsync method.
export function saveCallback(asyncResult) {
  if (asyncResult.status == Office.AsyncResultStatus.Failed) {
    console.error(MESSAGES.CANNOT_SAVE_CUSTOM_PROPS);
  }
}
